<script setup lang="ts">
	import {useCookieConsentStore} from '@/scripts/stores/cookie-consent';
	import {trans} from 'laravel-vue-i18n';
	import {Button} from '@/views/components/ui/button';
	import {Cookie} from 'lucide-vue-next';

	const cookieStore = useCookieConsentStore();
</script>

<template>
	<Button
		@click="cookieStore.openSettings"
		variant="ghost"
		size="sm"
		class="text-muted-foreground hover:text-primary h-auto p-0 transition-colors"
	>
		<Cookie class="mr-1 h-3 w-3" />
		{{ trans('cookie_consent.trigger.manage_cookies') }}
	</Button>
</template>
